import { CameraType, PlaygroundShapeType } from '@/types/creator';
import { em } from '@mantine/core';

const APP_CONFIG = {
	QUERY_STALE_TIME: 30_000,
	QUERY_CACHE_TIME: 1_800_000,
	QUERY_RETRY: 2,
	Z_INDEX: {
		CSS_2D_RENDERER: 5,
		TOOLBAR: 10,
		OVERLAY: 50,
		SCROLL_TOP: 50,
		NOTIFICATION: 100,
		MOBILE_TOOLBAR: 300,
		DRAWER: 301,
		MODAL: 301,
		POPOVER: 302,
		TOOLTIP: 302,
		SELECT: 302,
		CREATOR_LOADING: 303,
		MODEL_VIEWER: 304,
		MODAL_INSTRUCTION: 504,
		TUTORIAL_OVERLAY: 505,
		TUTORIAL_ITEM: 506,
		LANGUAGE_SELECT_DROPDOWN: 507,
		INSTRUCTIONS_MODAL: 507,
		TUTORIAL_BUTTON: 507,
	},
	BREAKPOINTS: {
		XS: em(576),
		SM: em(768),
		MD: em(992),
		LG: em(1200),
		XL: em(1408),
	},
	DEFAULT_LANGUAGE: 'PL',
	DEFAULT_SHAPE_TYPE: PlaygroundShapeType.RECTANGLE,
	DEFAULT_CAMERA: CameraType.ORTHOGRAPHIC,
	DEFAULT_CODES_VISIBLITY: false,
	DEFAULT_TRANSFORM_MODE: 'translate',
	HOTKEYS: {
		TOGGLE_TRANSFORM_MODE: 't',
	},
	PREVIEW_PARAM: 'preview_project',
	PARTNER_ID_PARAM: 'partnerId',
	PARTNER_ID_HEADER: 'x-partner-id',
	IS_ADMIN_PARAM: 'is_admin',
	COMPANY_CONTACT: {
		EMAIL: 'kontakt@novum4kids.com',
		PHONE: '+48 89 623 29 85',
	},
	AUTO_SAVE: {
		KEY: 'tempProject',
		INTERVAL: 60_000,
	},
	SCREENSHOT_CAMERS: {
		MAX_QUANTITY: 5,
	},
	MOBILE_DRAWER_SWIPE_THRESHOLD: 150,
} as const;

export default APP_CONFIG;
